import { Link } from "@mantine/tiptap";
import { useEditor } from "@tiptap/react";
import Highlight from "@tiptap/extension-highlight";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import TextAlign from "@tiptap/extension-text-align";
import Superscript from "@tiptap/extension-superscript";
import SubScript from "@tiptap/extension-subscript";
import { Color } from "@tiptap/extension-color";
import { TextStyle } from "@tiptap/extension-text-style";
import TextDirection from "tiptap-text-direction";

export const useEmailEditor = (initialContent: string, language?: string) => {
  const isHebrew = language?.toLowerCase() === "hebrew";
  
  return useEditor({
    extensions: [
      StarterKit.configure({
        bulletList: {
          HTMLAttributes: {
            class: "list-disc",
          },
        },
        orderedList: {
          HTMLAttributes: {
            class: "list-decimal",
          },
        },
      }),
      Underline,
      Link,
      Superscript,
      SubScript,
      Highlight,
      Color,
      TextStyle,
      TextAlign.configure({
        types: [
          "heading",
          "paragraph",
          "listItem",
          "bulletList",
          "orderedList",
        ],
        // This is a small hack to make the TextDirection work. Without it, the defaultAlignment will be "left".
        // And so clicking on the left alignment button will not set any text-alignment. And if the text is in Hebrew,
        // it won't get aligned to the left when clicking this button, unless we explicitly set the text-alignment to "left".
        defaultAlignment: "none",
      }),
      TextDirection.configure({
        types: [
          "heading",
          "paragraph",
          "listItem",
          "bulletList",
          "orderedList",
        ],
      }),
    ],
    content: initialContent,
    editorProps: {
      attributes: {
        dir: isHebrew ? "rtl" : "ltr",
      },
    },
    onCreate: ({ editor }) => {
      if (isHebrew) {
        editor.view.dom.setAttribute("dir", "rtl");
      }
    },
    onUpdate: ({ editor }) => {
      // Ensure RTL is maintained when Hebrew is detected
      if (isHebrew && editor.view.dom.getAttribute("dir") !== "rtl") {
        editor.view.dom.setAttribute("dir", "rtl");
      }
    },
  });
};
